import { render, staticRenderFns } from "./Security_Authorization.vue?vue&type=template&id=98b35612&scoped=true&"
import script from "./Security_Authorization.vue?vue&type=script&lang=js&"
export * from "./Security_Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Security_Authorization.vue?vue&type=style&index=0&id=98b35612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b35612",
  null
  
)

export default component.exports